module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11Qzavs/tc-custom/9781439661284.jpg?1705026122840",
      "alt": "This image is the cover for the book St. Charles, Missouri, Brief History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("St. Charles, Missouri, Brief History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Louis Blanchette came to Les Petites Côtes (the Little Hills) in 1769. The little village, later dubbed San Carlos del Misury by the Spanish and St. Charles by the Americans, played a major role in the early history of Missouri. It launched Lewis and Clark's expedition, as well as countless other westbound settlers. It served as the first capital of the new state. Important politicians, judges, soldiers, businesspersons, educators and even a saint all called St. Charles home. Despite its rapid growth from a sleepy French village into a dynamic city amid one of the fastest-growing regions in the country, St. Charles never forgot its history. Author James Erwin tells the story of its fascinating heritage.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James W. Erwin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James W. Erwin graduated from Missouri State University with a BA in mathematics. After service in the United States Army, he obtained an MA in history from the University of Missouri and a JD from the University of Missouri Law School. He practiced law in St. Louis for more than thirty-seven years. Mr. Erwin and his wife, Vicki Berger Erwin, owned a bookstore in the Main Street Historic District in St. Charles for eight years. They live in Kirkwood, Missouri.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0